module.exports = "/_next/static/images/17fd4a60f8574ec16bc40cce84894482-desktop-lg.jpg";